var modules_51430e0a = {"container":"MenuItem_module_container__0d7ec402"};
import "../../../assets/esm/components/GlobalSearch/MenuItem~D8pLHI1R.css";

export { modules_51430e0a as default };
//# sourceMappingURL=MenuItem.module.less.js.map
